const state = {
  current_aid: undefined,
  current_plat_type: undefined,
  card_list: [],
  loading: false,
  card_list_map: {},
};

const mutations = {
  SET_CURRENT_ACCOUNT(state, { aid, plat_type }) {
    state.current_aid = aid;
    state.current_plat_type = plat_type;
    state.card_list = state.card_list_map[aid]?.list || [];
  },
  SET_CURRENT_AID(state, aid) {
    state.current_aid = aid;
    state.card_list = state.card_list_map[aid]?.list || [];
  },
  SET_CURRENT_PLAT_TYPE(state, platType) {
    state.current_plat_type = platType;
  },
  SET_CARD_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_CARD_LIST(state, data) {
    state.card_list = data || [];
  },
  SET_ACCOUNT_CARD_LIST(state, { aid, list, source, updated_at }) {
    if (!aid) {
      return;
    }
    state.card_list_map = {
      ...state.card_list_map,
      [aid]: {
        aid,
        list: list || [],
        source,
        updated_at: updated_at || Date.now(),
      },
    };
    if (String(aid) === String(state.current_aid)) {
      state.card_list = list || [];
    }
  },
  CLEAR_CURRENT_CARD_LIST(state) {
    state.card_list = [];
  },
};

const actions = {};

const getters = {
  current_aid: (state) => state.current_aid,
  current_plat_type: (state) => state.current_plat_type,
  current_account: (state) => ({
    aid: state.current_aid,
    plat_type: state.current_plat_type,
  }),
  card_list: (state) => state.card_list,
  card_loading: (state) => state.loading,
  account_card_list: (state) => (aid) => state.card_list_map[aid]?.list || [],
  account_card_info: (state) => (aid) => state.card_list_map[aid],
  current_account_card_info: (state) => state.card_list_map[state.current_aid] || { list: [] },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
